import Vue from 'vue'
import VueRouter from 'vue-router'
import LoginRoutes from '@/modules/Login/Routes'
import DashboardRoutes from '@/modules/Dashboard/Routes'
import EmployeesRoutes from '@/modules/Employees/Routes'
import AreaRoutes from '@/modules/Areas/Routes'
import CompaniesRoutes from '@/modules/Companies/Routes'
import ContractRoutes from '@/modules/Contracts/Routes'
import PositionRoutes from '@/modules/Positions/Routes'
import PayrollRoutes from '@/modules/Payrolls/Routes'
import AuditLogRoutes from '@/modules/AuditLog/Routes'
import VacationRoutes from '@/modules/Vacations/Routes'
import MedicalLeaveRoutes from '@/modules/MedicalLeaves/Routes'
import LicensesRoutes from '@/modules/Licenses/Routes'
import PensionEntityRoutes from '@/modules/PensionEntities/Routes'
import WorkSiteRoutes from '@/modules/WorkSites/Routes'
import DocumentTypeRoutes from '@/modules/DocumentTypes/Routes'
import LegalParameterRoutes from '@/modules/LegalParameters/Routes'
import CustomFieldRoutes from '@/modules/CustomFields/Routes'
import SignerRoleRoutes from '@/modules/SignerRoles/Routes'
import LegajoRoutes from '@/modules/Legajo/Routes'
import SignatureRoutes from '@/modules/Signatures/Routes'
import WorkScheduleRoutes from '@/modules/WorkSchedules/Routes'
import AttendanceRoutes from '@/modules/Attendance/Routes'
import BankRoutes from '@/modules/Banks/Routes'
import PayrollConceptRoutes from '@/modules/PayrollConcepts/Routes'
import ChannelRoutes from '@/modules/Channels/Routes'
import ExpenseLineRoutes from '@/modules/ExpenseLines/Routes'
import PayrollTypeRoutes from '@/modules/PayrollTypes/Routes'
import CessationReasonRoutes from '@/modules/CessationReasons/Routes'
import LeaveTypeRoutes from '@/modules/LeaveTypes/Routes'
import GratificationRoutes from '@/modules/Gratifications/Routes'
import CtsRoutes from '@/modules/Cts/Routes'
import SeveranceRoutes from '@/modules/Severance/Routes'
import ContractTemplateRoutes from '@/modules/ContractTemplates/Routes'
import OperationalPaymentConceptRoutes from '@/modules/OperationalPaymentConcepts/Routes'
import OperationalPaymentRoutes from '@/modules/OperationalPayments/Routes'
import store from '../store'
import { defineAbilitiesFor} from '@/core/plugins/abilities'

Vue.use(VueRouter);

let routes = [];

routes = routes.concat(CustomFieldRoutes, SignerRoleRoutes, LegajoRoutes, SignatureRoutes, LoginRoutes, DashboardRoutes, EmployeesRoutes, AreaRoutes, CompaniesRoutes, PositionRoutes, ContractRoutes, PayrollRoutes, AuditLogRoutes, VacationRoutes, MedicalLeaveRoutes, PensionEntityRoutes, WorkSiteRoutes, DocumentTypeRoutes, LegalParameterRoutes, WorkScheduleRoutes, AttendanceRoutes, BankRoutes, PayrollConceptRoutes, ChannelRoutes, ExpenseLineRoutes, PayrollTypeRoutes, CessationReasonRoutes, LicensesRoutes, LeaveTypeRoutes, GratificationRoutes, CtsRoutes, SeveranceRoutes, ContractTemplateRoutes, OperationalPaymentConceptRoutes, OperationalPaymentRoutes);

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

const canNavigate = () => {
  return true // ability.can('manage', to.name) || to.meta.excludeAuth || to.path === '/404';
};

router.beforeEach(async (to, from, next) => {
  if (to.meta.excludeAuth) {
    if (!store.getters['auth/isAuthenticated']) {
      next();
    } else {
      next({name: 'dashboard'})
    }

  } else {
    if (store.getters['auth/isAuthenticated']) {
      if (!store.getters['auth/isTokenValid']) {
        try {
          await store.dispatch('auth/checkValidToken')
          const user = store.getters['auth/getUser']
          defineAbilitiesFor(user.roles)
          if (canNavigate(to)) {
            next();
          } else {
            next({name: "dashboard"});
          }
        } catch (e) {
          console.error(e)
          next({name: 'login'});
        }
      } else {
        if (canNavigate(to)) {
          next();
        } else {
          next({name: "dashboard"});
        }
      }
    } else {
      next({name: 'login'});
    }
  }
});

export default router
